import React from 'react';
import './Editable.css';
import 'react-phone-number-input/style.css'
import '../../App/Styles.css'
import {Editable, EditableProps} from "./Editable";
import {useEditable} from "./EditableContext";

export const EditableYesNo = <EnclosingType extends object>(props: EditableProps<EnclosingType, boolean>) => {

  const {editing, mode, value, setValue} = useEditable(props);

  return <Editable {...props}>
    {editing && <input className={'EditableCheckbox'}
                       type={'checkbox'}
                       checked={value ?? false}
                       onChange={(e) => {
                         setValue(e.target.checked);
                       }}/>}
    {!editing && <div className={'EditableNotEditing'}>{value ? 'Yes' : 'No'}</div>}
  </Editable>
}